<div class="user-button selection-tile" [class.selected]="selected" [class.suspended]="useStatus && useStatus === 'suspended'">
    <div class="d-flex flex-column gap--2 w-100 overflow-hidden">
        <h4>{{ name }}</h4>
    </div>
    <app-icon *ngIf="selected && !disallowRemove" class="se-icon-button no-bg" src="close" (click)="remove($event)"></app-icon>
    <small class="type-label" *ngIf="type && (!selected || disallowRemove)">{{ capitalizeFirstChar(type) }}</small>
</div>